export enum IssueEffectivenessCode {
  /**
   * 有效
   */
  EFFECTIVE = '200',
  /**
   * 身份已过期
   */
  IDENTITY_EXPIRE = '30601',
  /**
   * 非有效期别无法学习
   */
  NOT_EFFECTIVE_ISSUE = '30602',
  /**
   * 期数已过期 | 当前期数已停止培训
   */
  EXPIRED = '30603',
  /**
   * 当前期数未开始培训
   */
  ISSUE_NOT_START_TRAINING = '30604',
  /**
   * 期数退款冻结 | 期数预约已冻结
   */
  REFUND_FROZEN = '30605',
  /**
   * 期数已失效 | 期数预约已失效
   */
  INVALID = '30606'
  // public static final ApplyTokenErrorCode IDENTITY_EXPIRE = new ApplyTokenErrorCode("01","身份已过期");
  // public static final ApplyTokenErrorCode NOT_EFFECTIVE_ISSUE = new ApplyTokenErrorCode("02","非有效期别无法学习");
  // public static final ApplyTokenErrorCode ISSUE_TRAINING_END = new ApplyTokenErrorCode("03","当前期数已停止培训");
  // public static final ApplyTokenErrorCode ISSUE_NOT_START_TRAINING = new ApplyTokenErrorCode("04","当前期数未开始培训");
  // public static final ApplyTokenErrorCode ISSUE_RESERVATION_FROZEN = new ApplyTokenErrorCode("05","期数预约已冻结");
  // public static final ApplyTokenErrorCode ISSUE_RESERVATION_INVALID = new ApplyTokenErrorCode("06","期数预约已失效");
}

/**
 * 有效性
 */
class Effectiveness {
  /**
   * 期数id
   */
  issueId: string
  /**
   * 是否有效
   */
  isEffective = false
  /**
   * 代码
   */
  code = IssueEffectivenessCode.INVALID
  /**
   * 信息
   */
  message = ''
}

export default Effectiveness
